module.exports = __webpack_public_path__ + "static/media/banner.77484f94.jpg";